const Footer = () => {
    return (
        <>
            <p className="text-center">Todos os direitos reservados.</p>
            <p className="text-center">Caso possua interesse em meus serviços sinta-se avontade para entrar em contato.</p>
        </>
    )
}

export default Footer